import { render } from "./RolList.vue?vue&type=template&id=57585b26&scoped=true"
import script from "./RolList.vue?vue&type=script&lang=js"
export * from "./RolList.vue?vue&type=script&lang=js"

import "./RolList.vue?vue&type=style&index=0&id=57585b26&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57585b26"]])

export default __exports__